"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _CurrencyFormat = require("./CurrencyFormat.types");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function AmountCard(_ref) {
  var title = _ref.title,
    amount = _ref.amount,
    currencyId = _ref.currencyId;
  var _a;
  return /*#__PURE__*/_react["default"].createElement(_material.Card, {
    variant: "outlined"
  }, /*#__PURE__*/_react["default"].createElement(_material.CardContent, {
    sx: function sx(theme) {
      return {
        pb: "".concat(theme.spacing(2), " !important"),
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100]
      };
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    textAlign: "center",
    component: "h6"
  }, title), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "h6",
    textAlign: "center"
  }, amount !== undefined && currencyId ? (_a = (0, _CurrencyFormat.formatCurrecy)({
    value: amount,
    currencyId: currencyId
  })) !== null && _a !== void 0 ? _a : '---' : '---')));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AmountCard);